// Split by newline only if it has newlines, otherwise do it by comma.
const getUspDelimiter = (usp_items) => (usp_items?.includes('\n') ? '\n' : ',');

export default getUspDelimiter;
